// The "Web Page" streaming vendor (any spelling: "Web Page", "Webpage", "web-page", and
// cme-common's "webpage"): its stream is a link the admin typed in - a custom src with no
// Mux behind it, so it has no health telemetry and need not be live.
export function isWebPageVendor(label) {
  return /\bweb[\s_-]*page\b/i.test(String(label ?? ""));
}
